import { connect } from 'react-redux'
import RegionLanguageComponent from '../components/RegionLanguageComponent'

const mapStateToProps = ({ userAccount, display }) => ({
    currency: userAccount.currency,
    billingCountry: userAccount.billingCountry,
    invoiceIssuingCountry: userAccount.invoiceIssuingCountry,
    editCampaignActive: display.editCampaignActive,
    campaignCurrency: display.campaignCurrency,
    campaignInvoiceIssuingCountry: display.campaignInvoiceIssuingCountry,
    campaignBillingCountry: display.campaignBillingCountry,
})

export default connect(mapStateToProps)(RegionLanguageComponent)
